import script from "./NewComplaintDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NewComplaintDialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__